import { render, staticRenderFns } from "./AddYaka.vue?vue&type=template&id=4e142444&scoped=true&"
import script from "./AddYaka.vue?vue&type=script&lang=js&"
export * from "./AddYaka.vue?vue&type=script&lang=js&"
import style0 from "./AddYaka.vue?vue&type=style&index=0&id=4e142444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e142444",
  null
  
)

export default component.exports